import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SysLimiters } from '@core/limiters/limiters.model';
import { SystemChannelCode } from '@core/models/system-channel-code.model';
import { AbstractForm } from '@root/abstract/form';
import { PATTERN_EMAIL } from '@shared/constants';
import { compareValidator } from '@utils/validators/compare.validator';


export enum RecoverFormField {
    Code = 'code',
    Phone = 'phone',
    Email = 'email',
    Password = 'password',
    ConfirmPassword = 'confirmPassword',
    SysCode = 'sysCode',
}

export interface RecoverFormModel {
    [RecoverFormField.Code]: FormControl<string | null>;
    [RecoverFormField.Phone]: FormControl<string | null>;
    [RecoverFormField.Email]: FormControl<string | null>;
    [RecoverFormField.Password]: FormControl<string | null>;
    [RecoverFormField.ConfirmPassword]: FormControl<string | null>;
    [RecoverFormField.SysCode]: FormControl<SystemChannelCode | null>;
}

@Injectable()
export class RecoverFormService extends AbstractForm<RecoverFormField, RecoverFormModel> {
    public createReactiveForm(): FormGroup<RecoverFormModel> {
        this.build({
            [RecoverFormField.Code]: new FormControl<string | null>(null, [Validators.required]),
            [RecoverFormField.Phone]: new FormControl<string | null>(null, [Validators.required]),
            [RecoverFormField.Email]: new FormControl<string | null>(null, [Validators.pattern(PATTERN_EMAIL)]),
            [RecoverFormField.Password]: new FormControl<string | null>(null, [
                Validators.required,
                Validators.minLength(SysLimiters.PasswordMinLength),
                Validators.maxLength(SysLimiters.PasswordMaxLength),
                compareValidator(RecoverFormField.ConfirmPassword),
            ]),
            [RecoverFormField.ConfirmPassword]: new FormControl<string | null>(null, [
                Validators.required,
                Validators.minLength(SysLimiters.PasswordMinLength),
                Validators.maxLength(SysLimiters.PasswordMaxLength),
            ]),
            [RecoverFormField.SysCode]: new FormControl<SystemChannelCode | null>(SystemChannelCode.Sms, []),
        });

        this.defineMechanics();

        return this.form;
    }

    private defineMechanics(): void {
        this.watchForValueChanges(RecoverFormField.SysCode).subscribe((value: SystemChannelCode) => {
            if (value === SystemChannelCode.Sms) {
                this.getControlByPath(RecoverFormField.Phone).enable();
                this.getControlByPath(RecoverFormField.Email).disable();
            } else if (value === SystemChannelCode.Email) {
                this.getControlByPath(RecoverFormField.Phone).disable();
                this.getControlByPath(RecoverFormField.Email).enable();
            }
        });
    }
}
